<div class="fluid-container">
  <div class="card">
    <div class="card-header filter">
      <span class="filterspan">
        Recharge
      </span>
    </div>
    <div class="card-body">
      <div class="col-12 col-sm-6 col-md-4 col-lg-3" *ngIf="preselectedLocation">

        <button class="btn w-100 text-start border">
          {{ selectedLocation?.location_no }}
        </button>

      </div>
      <div class="col-12 col-sm-6 col-md-4 col-lg-3" *ngIf="!preselectedLocation">
        <div ngbDropdown class="w-100">
          <button class="btn dropdown-toggle w-100 d-flex justify-content-between align-items-center" ngbDropdownToggle>
            {{ selectedLocation?.location_no || 'Unit No'}}
          </button>

          <ul class="dropdown-menu dropdown-block" ngbDropdownMenu
            style="min-width: 250px; max-height: 300px; overflow-y: auto;">

            <!-- Search -->
            <li class="px-1 py-1 sticky-top bg-white search-container">
              <img src="assets/DashboardIcon/searchicon.svg" alt="searchicon"
                style="position: absolute; right: 7px; top: 7px;">
              <input type="text" class="form-control form-control-sm searchbar" placeholder="Search Unit..."
                [(ngModel)]="locationSearchTerm" (click)="$event.stopPropagation()">
            </li>

            <li>
              <hr class="dropdown-divider mt-1 mb-0">
            </li>

            <!-- Location list -->
            <div style="height: 250px; width: 100%; overflow-y: auto;">
              <li class="list" *ngFor="let location of filteredLocations">
                <a class="dropdown-item px-2 py-1" href="javascript:void(0)" (click)="onlocationSelect(location)">
                  <!-- {{location.id}} -->
                  {{ location.location_no }}
                </a>
              </li>

              <!-- Empty states -->
              <li *ngIf="filteredLocations.length === 0" class="px-3 py-2 text-muted text-center">
                No Units found.
              </li>
            </div>

          </ul>

        </div>
      </div>
      <div *ngIf="showform" class="col-12">
        <hr>
        <app-form-setup [FromJson]="formConfig" (formEmitted)="submitform($event)" (formCheck)="formSubmit($event)"
          [submitForm]="callForForm">
        </app-form-setup>
        <button (click)="triggerSubmit()" class="btn btn-primary" [disabled]="!isFormValid">Recharge</button>
      </div>
    </div>
  </div>
</div>